export default function reasons(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                reason: action.reason,
            }
        default:
            return state;
    }
}
